module.exports = __webpack_public_path__ + "media/images/30px_fullstar-bc49ca46742402239a7dc5e46aa683f326bea0335f6000300fc034d7e82704e8.png";